import { useReadableEventRefresher } from '@zdr-tools/zdr-react';
import { useSignInFacade } from './useSignInFacade.js';
/**
 * Reads the login site's sign-in state, re-rendering the caller whenever any part of it changes — including every
 * second of the resend countdown. A component that needs only the step should use `useSignInStep()` instead.
 *
 * Takes no parameters: there is a single sign-in per page. It starts nothing — every request goes through
 * `useSignInFacade()`.
 *
 * @returns The current `ISignInView`. The sign-in always exists, so there is no "not found" case: before anything
 * happens it is on step `EMAIL`, `IDLE`, with an empty email, no failure, no notice, 0 seconds until resend, an unusable
 * code, not busy, no new code to request and a failure revision of 0.
 * @throws Error `useSignInFacade must be used within SignInContextProvider` when called outside a
 * `SignInContextProvider`.
 */
export function useSignIn() {
    const signIn = useSignInFacade().getSignIn();
    const [[step], [email], [activity], [loadingState], [failure], [attemptsLeft], [notice], [secondsUntilResend], [isCodeUsable], [isBusy], [canRequestNewCode], [failureRevision]] = useReadableEventRefresher(signIn.step, signIn.email, signIn.activity, signIn.loadingState, signIn.failure, signIn.attemptsLeft, signIn.notice, signIn.secondsUntilResend, signIn.isCodeUsable, signIn.isBusy, signIn.canRequestNewCode, signIn.failureRevision);
    return { step, email, activity, loadingState, failure, attemptsLeft, notice, secondsUntilResend, isCodeUsable, isBusy, canRequestNewCode, failureRevision };
}
//# sourceMappingURL=useSignIn.js.map